const URL = process.env.REACT_APP_API;

export const BASE_URL = `${URL}`;
export const BASE_MEDIA = `${URL}/files`;
export const BASE_IMAGES = `${URL}/images`;

console.log('URL',URL);
